<template>

  <RadioGroup v-model="selected_value" class="mt-2">
    <div class="grid grid-cols-3 gap-3">
      <RadioGroupOption
        as="template"
        v-for="(exportation_status) in exportation_statuses"
        :key="exportation_status.id"
        :value="exportation_status.id"
        v-slot="{ active, checked }"
      >
        <div
          :class="[
            'cursor-pointer focus:outline-none',
            active
              ? 'ring-2 ring-offset-2 ring-'+(exportation_status.color)+'-500'
              : '',
            checked
              ? 'bg-'+(exportation_status.color)+'-100 border-transparent text-'+(exportation_status.color)+'-800 hover:bg-'+(exportation_status.color)+'-100'
              : 'bg-white border-gray-200 text-gray-900 hover:bg-gray-50',
            'border rounded-md py-1 px-1 flex items-center justify-center text-sm font-medium sm:flex-1',
          ]"
        >
          <RadioGroupLabel as="span">
            {{ exportation_status.name }}
          </RadioGroupLabel>
        </div>
      </RadioGroupOption>
    </div>
  </RadioGroup>
</template>

<script>
import { RadioGroup, RadioGroupLabel, RadioGroupOption } from "@headlessui/vue";

export default {
  ame: "AEProductionBasicContainerExportExportationStatusSelector",
  components: { RadioGroup, RadioGroupLabel, RadioGroupOption },
  props: ["modelValue"],
  data() {
    return {
      selected_value: this.modelValue,
      exportation_statuses: [
        {id: 0, name: 'Preparando', color: 'yellow'},
        {id: 1, name: 'Viajando', color: 'blue'},
        {id: 2, name: 'Llegó', color: 'green'},
      ]
    };
  },
  updated() {
    this.selected_value = this.modelValue;
  },
  watch: {
    selected_value: function (newValue) {
      this.$emit("update:modelValue", newValue);
    },
  },
};
</script>